export default __webpack_public_path__ + "static/media/3116.740f14a3.jpg";